'use strict';

(function ($) {
    $.ajaxCORS = function (url, method, data, successCallBack, errorCallBack) {
        $.ajax({
            url: url,
            type: method,
            data: data,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (res) {
                if($.isFunction(successCallBack)) {
                    successCallBack(res);
                }
            },
            error: function (xhr, status) {
                if($.isFunction(errorCallBack)) {
                    errorCallBack(xhr, status);
                }
            }
        });
    };
    
    $.getCORS = function (url, successCallBack, errorCallBack) {
        $.ajaxCORS(url, 'GET', '', successCallBack, errorCallBack);
    };
    
    $.postCORS = function (url, data, successCallBack, errorCallBack) {
        $.ajaxCORS(url, 'POST', data, successCallBack, errorCallBack);
    };
})(jQuery);
